import { SegmentFieldItem } from 'utils/segment-field-item.interface';

/* eslint-disable */
export const pricingSegmentData: Array<SegmentFieldItem> = [
  {
      "item_name": "JBR",
      "title": "Jobber",
      "hint_detail": "An industry standard price point used to determine wholesale prices. This price is often lower than retail but higher than wholesaler price.",
      "hint_panel" : "An industry standard price point used to determine wholesale prices. This price is often lower than retail but higher than wholesaler price.",
      "example": "10.15",
      "sequence": 1,
      "show_more": true,
      "lookup": null
  },
  {
      "item_name": "RET",
      "title": "Retail",
      "hint_detail": "Suggested price to the general public.",
      "hint_panel" : "Suggested price to the general public.",
      "example": "",
      "sequence": 2,
      "show_more": true,
      "lookup": null
  },
  {
      "item_name": "RMP",
      "title": "Retail MAP",
      "hint_detail": "Minimum Advertised Price to the general public. This is not the same as unilateral price.",
      "hint_panel" : "Minimum Advertised Price to the general public. This is not the same as unilateral price.",
      "example": "",
      "sequence": 3,
      "show_more": true,
      "lookup": null
  },
  {
      "item_name": "WD1",
      "title": "Distributor",
      "hint_detail": "Distributor price is the same as the wholesaler or trade price.",
      "hint_panel" : "Distributor price is the same as the wholesaler or trade price.",
      "example": "",
      "sequence": 4,
      "show_more": true,
      "lookup": null
  },
  {
      "item_name": "WMP",
      "title": "Wholesale MAP",
      "hint_detail": "Minimum advertised price for wholesale customers.",
      "hint_panel" : "Minimum advertised price for wholesale customers.",
      "example": "",
      "sequence": 5,
      "show_more": true,
      "lookup": null
  },
  {
      "item_name": "AC1",
      "title": "Special additional cost 1",
      "hint_detail": "Additional costs including handling, freight charges, and other charges specific to the part.",
      "hint_panel" : "Additional costs including handling, freight charges, and other charges specific to the part.",
      "example": "",
      "sequence": 6,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "AC2",
      "title": "Special additional cost 2",
      "hint_detail": "Additional costs including handling, freight charges, and other charges specific to the part.",
      "hint_panel" : "Additional costs including handling, freight charges, and other charges specific to the part.",
      "example": "",
      "sequence": 7,
      "show_more": false,
      "lookup": null
  },
  {
    "item_name": "CWD",
    "title": "WD Cost",
    "hint_detail": "Warehouse distributor cost",
    "hint_panel" : "Warehouse distributor cost",
    "example": "",
    "sequence": 8,
    "show_more": false,
    "lookup": null,
  },
  {
      "item_name": "CR1",
      "title": "Core 1",
      "hint_detail": "Core 1 price",
      "hint_panel" : "Core 1 price",
      "example": "",
      "sequence": 9,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "CR2",
      "title": "Core 2",
      "hint_detail": "Core 2 price",
      "hint_panel" : "Core 2 price",
      "example": "",
      "sequence": 10,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "CR3",
      "title": "Core 3",
      "hint_detail": "Core 3 price",
      "hint_panel" : "Core 3 price",
      "example": "",
      "sequence": 11,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "CR4",
      "title": "Core 4",
      "hint_detail": "Core 4 price",
      "hint_panel" : "Core 4 price",
      "example": "",
      "sequence": 12,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "CRG",
      "title": "Good core",
      "hint_detail": "The sale of a remanufactured part involves a core price to be refunded to encourage the return of the old part for reconditioning purposes.",
      "hint_panel" : "The sale of a remanufactured part involves a core price to be refunded to encourage the return of the old part for reconditioning purposes.",
      "example": "",
      "sequence": 13,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "CRJ",
      "title": "Jobber core",
      "hint_detail": "Core price for jobbers.",
      "hint_panel" : "Core price for jobbers.",
      "example": "",
      "sequence": 14,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "CRW",
      "title": "WD core",
      "hint_detail": "Core price for warehouse distributors.",
      "hint_panel" : "Core price for warehouse distributors.",
      "example": "",
      "sequence": 15,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "DLN",
      "title": "Non-stock dealer",
      "hint_detail": "Non-stocking or drop shipping dealer.",
      "hint_panel" : "Non-stocking or drop shipping dealer.",
      "example": "",
      "sequence": 16,
      "show_more": false,
      "lookup": null
  },

  {
      "item_name": "DLR",
      "title": "Dealer",
      "hint_detail": "A wholesale price which can be the same or higher than Jobber price and lower than retail price.",
      "hint_panel" : "A wholesale price which can be the same or higher than Jobber price and lower than retail price.",
      "example": "",
      "sequence": 17,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "DLV",
      "title": "Volume dealer",
      "hint_detail": "A wholesale price for higher volumes which can be the same or higher than Jobber price and lower than retail price.",
      "hint_panel" : "A wholesale price for higher volumes which can be the same or higher than Jobber price and lower than retail price.",
      "example": "",
      "sequence": 18,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "FLT",
      "title": "Fleet",
      "hint_detail": "A special discount price for the purchase of multiple items used in a vehicle fleet.",
      "hint_panel" : "SA special discount price for the purchase of multiple items used in a vehicle fleet.",
      "example": "",
      "sequence": 19,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "INM",
      "title": "Master installer",
      "hint_detail": "Master installer",
      "hint_panel" : "Master installer",
      "example": "",
      "sequence": 20,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "INN",
      "title": "NS installer",
      "hint_detail": "NS installer",
      "hint_panel" : "NS installer",
      "example": "",
      "sequence": 21,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "INP",
      "title": "Installer preferred",
      "hint_detail": "Installer preferred",
      "hint_panel" : "Installer preferred",
      "example": "",
      "sequence": 22,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "INS",
      "title": "Stocking installer",
      "hint_detail": "Stocking installer",
      "hint_panel" : "Stocking installer",
      "example": "",
      "sequence": 23,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "JBC",
      "title": "Conf-jobber",
      "hint_detail": "Conf-jobber",
      "hint_panel" : "Conf-jobber",
      "example": "",
      "sequence": 24,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "JBN",
      "title": "NS jobber",
      "hint_detail": "NS jobber",
      "hint_panel" : "NS jobber",
      "example": "",
      "sequence": 25,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "LST",
      "title": "List",
      "hint_detail": "List price is the same as the suggested retail price.",
      "hint_panel" : "List price is the same as the suggested retail price.",
      "example": "",
      "sequence": 26,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "MEC",
      "title": "Mechanic",
      "hint_detail": "Details hint - mechanic",
      "hint_panel" : "",
      "example": "",
      "sequence": 27,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "PKP",
      "title": "Pickup",
      "hint_detail": "Price when product is picked up by customer, free of freight burden.",
      "hint_panel" : "Price when product is picked up by customer, free of freight burden.",
      "example": "",
      "sequence": 28,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "PRO",
      "title": "Special promo",
      "hint_detail": "Lower price to get attention, or move excess inventory.",
      "hint_panel" : "Lower price to get attention, or move excess inventory.",
      "example": "",
      "sequence": 29,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "QOT",
      "title": "Quote",
      "hint_detail": "Quote",
      "hint_panel" : "Quote",
      "example": "",
      "sequence": 30,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "RAC",
      "title": "Racer",
      "hint_detail": "Wholesale price given to professional or amateur racers. This price is often lower than retail but higher than jobber.",
      "hint_panel" : "Wholesale price given to professional or amateur racers. This price is often lower than retail but higher than jobber.",
      "example": "",
      "sequence": 31,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "TRD",
      "title": "Trade",
      "hint_detail": "Trade price is the same as the wholesaler or distributor price.",
      "hint_panel" : "Trade price is the same as the wholesaler or distributor price.",
      "example": "",
      "sequence": 32,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "UNL",
      "title": "Unilateral price",
      "hint_detail": "The minimum sales price to the general public, including any discounts retailer may offer.",
      "hint_panel" : "The minimum sales price to the general public, including any discounts retailer may offer.",
      "example": "",
      "sequence": 33,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "WLS",
      "title": "Wholesale",
      "hint_detail": "Price for an industry or trade buyer. This price is often lower than jobber price.",
      "hint_panel" : "Price for an industry or trade buyer. This price is often lower than jobber price.",
      "example": "",
      "sequence": 34,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "ZZ1",
      "title": "User defined 1",
      "hint_detail": "User defined",
      "hint_panel" : "User defined",
      "example": "",
      "sequence": 35,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "ZZ2",
      "title": "User defined 2",
      "hint_detail": "User defined",
      "hint_panel" : "User defined",
      "example": "",
      "sequence": 36,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "ZZ3",
      "title": "User defined 3",
      "hint_detail": "User defined",
      "hint_panel" : "User defined",
      "example": "",
      "sequence": 37,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "ZZ4",
      "title": "User defined 4",
      "hint_detail": "User defined",
      "hint_panel" : "User defined",
      "example": "",
      "sequence": 38,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "ZZ5",
      "title": "User defined 5",
      "hint_detail": "User defined",
      "hint_panel" : "User defined",
      "example": "",
      "sequence": 39,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "ZZ6",
      "title": "User defined 6",
      "hint_detail": "User defined",
      "hint_panel" : "User defined",
      "example": "",
      "sequence": 40,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "ZZ7",
      "title": "User defined 7",
      "hint_detail": "User defined",
      "hint_panel" : "User defined",
      "example": "",
      "sequence": 41,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "ZZ8",
      "title": "User defined 8",
      "hint_detail": "User defined",
      "hint_panel" : "User defined",
      "example": "",
      "sequence": 42,
      "show_more": false,
      "lookup": null
  },
  {
      "item_name": "ZZ9",
      "title": "User defined 9",
      "hint_detail": "User defined",
      "hint_panel" : "User defined",
      "example": "",
      "sequence": 43,
      "show_more": false,
      "lookup": null
  },
  {
    "item_name": "XX1",
    "title": "Invalid Price Type",
    "hint_detail": "Invalid Price Type please remove",
    "hint_panel" : "Invalid Price Type please remove",
    "example": "",
    "sequence": 44,
    "show_more": false,
    "lookup": null,
    "is_invalid": true
  },
];
/* eslint-enable */
